// Sites.jsx
import React, { useState, useEffect } from 'react';
import SiteTable from '../components/SiteTable';
import Header from '../components/Header';
import './Sites.css';
import config from '../config'

const Sites = () => {
  const [siteData, setSiteData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(config.api.siteData);
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
        setSiteData(data);
      } catch (error) {
        console.error('Error fetching site data:', error);
      }
    };
  
    fetchData();
  }, []);

  return (
    <div className="container">
      <div className="header">
        <Header />
      </div>
      <div className="sites-container">
        {siteData ? <SiteTable data={siteData} /> : <p>Loading...</p>}
      </div>
    </div>
  );
};

export default Sites;
